import { makeAutoObservable } from "mobx";

export class AdminStore {
  role = "";
  windowWidth = window.innerWidth;
  shouldAnnounceErrModal = true;
  constructor() {
    makeAutoObservable(this);
    window.addEventListener("resize", this.handleResize);
  }
  getRole() {
    return this.role;
  }
  setRole(data: any) {
    this.role = data;
  }
  handleResize = () => {
    this.windowWidth = window.innerWidth;
  };
  updateShouldAnnounceErrModal(should: boolean) {
    this.shouldAnnounceErrModal = should;
  }
}
export const adminStore = new AdminStore();
